export default __webpack_public_path__ + "static/media/il-borgo.de0217c1.jpg";